<template>
  <PDialogStyles />
  <Dialog v-bind="$attrs" :class="{ 'p-dialog--fit-viewport': fitViewport }">
    <template #closebutton="{ closeCallback }">
      <SButtonIcon
        action-type="quaternary"
        aria-label="Close"
        color="gray"
        icon="far fa-xmark"
        rounded
        @click="closeCallback"
      />
    </template>
    <template #maximizebutton="{ maximizeCallback, maximized }">
      <SButtonIcon
        action-type="quaternary"
        :aria-label="maximized ? 'Minimize' : 'Maximize'"
        color="gray"
        :icon="maximized ? 'far fa-arrows-minimize' : 'far fa-arrows-maximize'"
        rounded
        @click="maximizeCallback"
      />
    </template>
    <template v-for="(_, slotName) in $slots" #[slotName]="slotProps">
      <slot :name="slotName" v-bind="slotProps ?? {}" />
    </template>
  </Dialog>
</template>

<script setup lang="ts">
import type { DialogEmits, DialogProps } from "primevue";

import { Dialog } from "primevue";

import { SButtonIcon } from "@solvari/common-fe";

import PDialogStyles from "./PDialogStyles.vue";

withDefaults(
  defineProps<
    /* @vue-ignore */ Omit<
      DialogProps,
      "closeButtonProps" | "maximizeButtonProps"
    > & {
      /** Cap the dialog to the viewport; its content scrolls instead of the overlay. */
      fitViewport?: boolean;
    }
  >(),
  { draggable: false, fitViewport: false },
);
defineOptions({ inheritAttrs: false });
defineEmits</* @vue-ignore */ DialogEmits>();
</script>
